import * as React from 'react';
import { ICON_SIZE_MAP } from '../helpers/size.js';
const ChevronDownIcon = React.forwardRef((props, ref) => {
    const sizeKey = props.size !== undefined ? props.size : 1;
    const size = ICON_SIZE_MAP[sizeKey];
    return (React.createElement("svg", { width: size, height: size, fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, viewBox: "0 0 16 16" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.266 5.77a.9.9 0 0 1 1.286 0L8 9.272l3.448-3.502a.9.9 0 0 1 1.286 0 .933.933 0 0 1 0 1.306L8.643 11.23a.9.9 0 0 1-1.286 0l-4.09-4.154a.933.933 0 0 1 0-1.306Z", fill: "currentColor" })));
});
ChevronDownIcon.displayName = 'ChevronDownIcon';
export default ChevronDownIcon;
